import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import axios from 'axios'
import { Toaster } from 'react-hot-toast'

// Redux
import { createAppStore } from '@/store'

import App from '@/App'
import { unregister } from '@/services/serviceWorker'
import debugLogger from '@/utils/debug-logger'

import { checkIfLoggedIn } from '@/services/auth'
import { setRoute } from '@/services/router'

import config from '@/config/config-esm'

import './styles/index.css'
import './styles/main.scss'
import './styles/global-styles/index.scss'

const localStorer = (store) => (next) => (action) => {
  let result = next(action)
  const newState = store.getState()
  if (import.meta.env.VITE_USE_STORED_STATE) {
    try {
      if (action.type !== 'RESET_FORM_DATA') {
        window.localStorage.setItem('_state', JSON.stringify(newState))
      }
    } catch (e) {
      console.error('Unable to save state to local storage:', e)
    }
  }
  return result
}

const store = createAppStore(localStorer)

// Initialize debug logger with store
debugLogger.setStore(store)

// Export store for global access
export { store }

checkIfLoggedIn({ store: store })
setRoute({ store: store })

window.addEventListener('popstate', () => {
  setRoute({ store: store })
})

const triggerReload = () => {
  if (
    window.confirm(
      'Du har ikke siste versjonen av feltsalgsverktøyet. Vil du laste inn siste versjon?',
    )
  ) {
    window.location.reload()
  }
}

const checkScript = () => {
  // check if js file is accessable
  const scripts = document.getElementsByTagName('script')
  const myScript = scripts[scripts.length - 1]
  axios
    .get(myScript.src)
    .then((r) => console.log('Script ok'))
    .catch((e) => triggerReload())
}

if (!config.isLocal) {
  // setInterval(() => {
  //   checkScript()
  // }, 5000)
}

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(
    <Provider store={store}>
      <div className="app_wrapper">
        <App />
        <Toaster
          position="bottom-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              style: {
                background: '#4CAF50',
              },
            },
            error: {
              style: {
                background: '#f44336',
              },
            },
          }}
        />
      </div>
    </Provider>,
  )
}
unregister()
